// 랜딩(`/`, `/ko`)이 번역 XHR 없이 그려지도록 번들에 미리 넣는 번역.
//
// 구글은 JS 를 실행해 렌더링한 결과를 색인하는데, 번역 JSON 은 원래 브라우저에서 받아온다.
// 구글 렌더러에서 이 요청들이 실패하면 react-i18next 는 기다리지 않고 키를 그대로 그리고,
// 실제로 `/ko` 가 제목·본문 전부 번역 키인 상태로 색인됐다(2026-10). 랜딩이 쓰는
// common·landing 만 번들에 넣어 요청 실패와 무관하게 문구가 나오게 한다.
//
// - i18n 설정 세 파일(i18n.js / i18n.development.js / i18n.production.js)이 함께 쓴다.
//   CI 가 i18n.production.js 를 i18n.js 로 덮으므로 한쪽에만 넣으면 안 된다.
// - partialBundledLanguages: true 와 짝이다. 여기 없는 언어·namespace 는 기존대로 backend 가 받아온다.
// - 원본은 public/locales 그대로다. 번역을 고치면 다음 빌드에 같이 반영된다.
// - common 은 모든 페이지가 어차피 받던 파일이라 번들로 옮겨도 총 전송량은 거의 같다.
import enCommon from "../public/locales/en/common.json";
import enLanding from "../public/locales/en/landing.json";
import koCommon from "../public/locales/ko/common.json";
import koLanding from "../public/locales/ko/landing.json";

const bundledResources = {
  en: { common: enCommon, landing: enLanding },
  ko: { common: koCommon, landing: koLanding },
};

export default bundledResources;
